<template>
  <div class="wrapper">
    <div>
      <Form :model="reSearch" inline :label-width="90">
        <FormItem label="级别">
          <Select
            v-model="reSearch.grade_id"
            filterable
            clearable
            placeholder="请选择级别"
            style="width: 180px"
          >
            <Option v-for="item in scopeGradeList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="科目">
          <Select
            v-model="reSearch.subject_id"
            filterable
            clearable
            placeholder="请选择科目"
            style="width: 180px"
          >
            <Option v-for="item in scopeSubjectList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="名称">
          <Input v-model="reSearch.name" style="width: 8vw" clearable />
        </FormItem>
        <div style="float: right;padding-right: 15px;">
          <Button type="primary" @click="tabChange(labelMsg)" icon="ios-search">搜索</Button>
        </div>
        <div style="clear: both;"></div>
      </Form>
    </div>
    <Tabs @on-click="tabChange" :value="labelMsg">
      <TabPane label="我的录课" name="myRecordingCourse">
        <myCourse :reSearch="reSearch" ref="myCourse" />
      </TabPane>
      <TabPane label="录课库" name="addAndDeleteCourse">
        <allCourse :reSearch="reSearch" ref="allCourse" />
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
  import allCourse from "./allCourse"
  import myCourse from "./myCourse"
  import { mapState } from "vuex"
   import scopeSearch from "../../mixins/scopeSearch"
  export default {
    mixins: [scopeSearch],
    data() {
      return {
        labelMsg: "myRecordingCourse",
        curseLists: [],
        reSearch: {
          name: "",
          grade_id: "",
          subject_id: "",
        },
      }
    },
    computed: {
      ...mapState({
        curseList(state) {
          this.curseLists = state.global.curseList
        },
        subjectList(state) {
          return state.global.subjectList
        },
      }),
    },
    components: {
      allCourse,
      myCourse,
    },
    mounted() {
        this.scopeSearchInit()
      this.$store.dispatch("global/getAllSelect")
    },
    methods: {
      // 切换时初始化数据
      tabChange(name) {
        this.labelMsg = name
        if (name == "addAndDeleteCourse") {
          this.$refs.allCourse.search()
          this.$refs.allCourse.getData(1)
        } else if (name == "myRecordingCourse") {
          this.$refs.myCourse.search()
          this.$refs.myCourse.getData(1)
        }
      },
      getcurse() {
        this.$axios
          .get("/app/curse/getList", {
            subject_id: this.reSearch.subject_id,
          })
          .then((res) => {
            if (res.code == 1) {
              this.curseLists = res.data
            } else {
              this.$Message.error(res.msg)
            }
          })
      },
    },
  }
</script>
<style scoped lang="less">
  .wrapper {
    width: 98%;
    min-height: 58vh;
    margin: 10px auto;
  }
</style>
